import React, { useEffect, useRef } from "react";
import "./Verifyemail.scss";
import axios from "../../../utils/axios";

import { useNavigate } from "react-router";
import BaseDialog from "../../../modelDialogs/BaseDialog";

export default function Verifyemail() {
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const token = queryParameters.get("token");
  const navigate = useNavigate();
  const virifyIsRunning = useRef<boolean>(false);
  useEffect(() => {
    state._navigate = navigate;
  }, []);

  useEffect(() => {
    if (virifyIsRunning.current == true) {
      return;
    }
    if (token && id) {
      virifyIsRunning.current = true;
      axios
        .post(`/api/register/verify/${token}/${id}`, {})
        .then((result: any) => {
          virifyIsRunning.current = false;
          state.dialogManager.openDialog(
            <BaseDialog
              title={state.translate("Success", "Success")}
              onOk={() => {
                state.navigate("/login");
                return true;
              }}
              okCaption={state.translate("ok", "Ok")}
              noAbortButton={true}
            >
              <div style={{ padding: "20px" }}>
                {state.translate("verifyeEmail.emailVerified", "Your email has been Verified!")}
              </div>
            </BaseDialog>,
          );

          if (result.data.DATA.token) {
            state.navigate("/login");
          }
        })
        .catch((e) => {
          virifyIsRunning.current = false;
          if (e.STATUS === "FAILURE") {
            state.dialogManager.openDialog(
              <BaseDialog
                title={state.translate("error", "Error")}
                onOk={() => {
                  state.navigate("/login");
                  return true;
                }}
                okCaption={state.translate("ok", "Ok")}
                noAbortButton={true}
              >
                <div style={{ padding: "20px" }}>
                  {state.translate("setPassword.tokenExpired", "Token Expired. Please Try Again.")}
                </div>
              </BaseDialog>,
            );
          }
        });
    } else {
      state.dialogManager.openDialog(
        <BaseDialog
          title={state.translate("error", "Error")}
          onOk={() => {
            return true;
          }}
          okCaption={state.translate("ok", "Ok")}
          noAbortButton={true}
        >
          <div style={{ padding: "20px" }}>
            {state.translate("setPassword.somthingWentwrong", "Something Went Wrong. Please Try Again.")}
          </div>
        </BaseDialog>,
      );
    }
  }, []);

  return (
    <div id="App" className="App">
      <div className="Login">
        <div className="lView"></div>
        <div className="rView">
          <img
            src="/images/auth/rView.png" // no itx
            alt=""
          />
        </div>
        {/* <DialogHost /> */}
      </div>
    </div>
  );
}
